let noLoading = ["/customer/upload", '/customer/orc/idCardOrcByUrl', '/customer/orc/businessLicenseOrcByUrl', '/customer/winBidLoan/external/analyse', '/customer/common/queryWxappletMobileAuthResult', '/customer/lawsuitDocument/AiDocumentGenerate', '/customer/lawsuitDocument/addDocument'];
let loading = ["loading_home", "loading_el_alert_box", "loading_dg_form_dialog", "loading_el_form_dialog", 'loading_el_alert_box'];
export default class Topic {
  constructor() { }

  loadingOpen(url) {
    if (noLoading.indexOf(url) == -1) {
      loading.forEach((key) => {
        Mirror.emit(`${key}_open`, url);
      });
    }
  }
  loadingClose(url) {
    loading.forEach((key) => {
      Mirror.emit(`${key}_close`, url);
    });
  }
  tipsOpen(url, res) {
    Mirror.emit('tips_bus', res, url);
    // ["table_tips", "tips_dg_form_dialog"].forEach((key) => {
    //   Mirror.emit(`${key}_open`, res, url);
    // });
  }
  tipsClose(url, res) {
    ["table_tips", "tips_el_alert_box", "tips_dg_form_dialog"].forEach((key) => {
      Mirror.emit(`${key}_close`, res, url);
    });
  }
}
